// @ts-nocheck

import { reviewCheck, reviewOpenDialog, reviewCloseDialog } from '../../actions/review';
import { callNative, requestTypes } from '../../lib/bridge';
import { CommonActionTypes } from '../../types/actions/common';
import { ReviewActionTypes } from '../../types/actions/review';
import { type HandlerProps } from '../synchronousMiddleware';

export const handledActionTypes = [
  CommonActionTypes.RECEIVE_ENTITIES,
  ReviewActionTypes.CHECK,
  ReviewActionTypes.RATE,
  ReviewActionTypes.DISABLE,
];

const reviewMiddlewareHandler = ({ store: { dispatch }, action }: HandlerProps) => {
  if (~handledActionTypes.indexOf(action.type)) {
    switch (action.type) {
      case CommonActionTypes.RECEIVE_ENTITIES: {
        const { cc } = action.payload ?? {};
        if (cc && cc.shouldReview) {
          dispatch(reviewCheck());
        }
        break;
      }

      case ReviewActionTypes.CHECK: {
        const callAsync = async () => await callNative(requestTypes.REVIEW_CHECK);
        callAsync().then((res) => {
          if (res && res.data === 'js') {
            dispatch(reviewOpenDialog());
          } else if (res && res.data === 'native') {
            callNative(requestTypes.REVIEW_RATE);
          } else {
            console.debug(`%c rating | rating not available `, 'background: #b20e10; color: #fff;');
          }
        });
        break;
      }

      case ReviewActionTypes.RATE: {
        dispatch(reviewCloseDialog());
        callNative(requestTypes.REVIEW_RATE);
        break;
      }

      case ReviewActionTypes.DISABLE: {
        dispatch(reviewCloseDialog());
        callNative(requestTypes.REVIEW_DISABLE);
        break;
      }

      default:
    }
  }
};

export default reviewMiddlewareHandler;
